import WP_DATA from 'utils/wp_data'

export default [
  'click',
  'success',
  'error',
].reduce((prev, curr) => {
  if (typeof window !== 'undefined' && "Audio" in window) {
    const a = new Audio(`${WP_DATA.plugin_dir_url}/audio/${curr}.mp3`)
    a.volume = 0.1
    a.preload = 'auto'
    prev[curr] = a
  } else {
    prev[curr] = {play: () => console.log(`${curr}: no Audio`)}
  }
  return prev
}, {})